export default __webpack_public_path__ + "static/media/hht1_ani_11.584db095.png";